<div class="box-emergencia">
    <div class="wrapper">
        <div class="left">
            <a href="http://www.metrogas.cl/boletaelectronica"><img src="{{ textoImg.img }}" alt="Boleta electrónica" style="max-width:100%"></a>
        </div>
        <div class="right">
            <ngx-slick-carousel class="carousel fix-banner-inferior" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide">
                    <a href="http://www.metrogas.cl/boletaelectronica"><img src="{{ slide.img }}" alt="Boleta electrónica" width="" class="fix-img-mob"></a>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>